import React from "react"
import Hero from "./components/Hero"
import PrivacyPolicy from "./components/PrivacyPolicy"
import TermsOfService from "./components/TermsOfService"
import FoodSafetyPolicy from "./components/FoodSafetyPolicy"

const PolicyPage: React.FC = (): JSX.Element => {
  return (
    <div className="bg-white min-h-screen">
      <Hero />
      <div className="container mx-auto px-4 py-6">
        <PrivacyPolicy />
        <TermsOfService />
        <FoodSafetyPolicy />
      </div>
    </div>
  )
}

export default PolicyPage
